export default __webpack_public_path__ + "static/media/Pot3.b510bd06.svg";